/**
 * Component Entry
 *
 */

import CopyOnClick from './CopyOnClick'
export default CopyOnClick
export * from './CopyOnClick'
